import React, { Component as C } from "react"
import PropTypes from "prop-types"
import ResizeSensor from "css-element-queries/src/ResizeSensor"
import classNames from "classnames"

import styles from "./index.less"

const contentMargin = 20

export default class extends C {
  static propTypes = {
    isVisible: PropTypes.bool.isRequired,
  }
  state = {
    height: 0,
    isRender: false,
  }

  componentWillMount() {
    this.setState({
      isRender: this.props.isVisible,
    })
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      isRender: this.state.isRender || nextProps.isVisible,
    })
  }

  componentDidMount() {
    this._resizeSensor = new ResizeSensor(this._content, this.setHeight)
    this.setHeight()
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.isRender !== this.state.isRender) {
      this.setHeight()
    }
  }

  componentWillUnmount() {
    this._resizeSensor && this._resizeSensor.detach()
  }

  setHeight = () => {
    if (!this.state.isRender) {
      return
    }

    let height = this._content.clientHeight + contentMargin

    if (height === this.state.height) {
      return
    }

    this.setState({
      height,
    })
  }

  setContentRef = (content) => {
    this._content = content
  }

  render() {
    let height = this.props.isVisible ? `${this.state.height}px` : "0"

    return (
      <div className={classNames(styles.row, this.props.rowClassName)} style={{ height: height }}>
        <div
          className={classNames(styles.column, this.props.columnClassName)}
          style={{ height: height }}>
          <div className={styles.content} ref={this.setContentRef}>
            {this.state.isRender && this.props.children}
          </div>
        </div>
      </div>
    )
  }
}
